import { Component, inject, Input, OnInit } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';
import { QuestionBoxComponent } from '@shared/components/question-box/question-box.component';
import { defaultAnswerOptions } from '@shared/models/default-answer-options';
import { PremiumDisplayComponent } from '@shared/components/premium-display/premium-display.component';
import { NgClass } from '@angular/common';
import { startWith, switchMap, takeUntil } from 'rxjs';
import { CalculationErrorDisplayComponent } from '@shared/components/calculation-error-display/calculation-error-display.component';
import { DataBaseComponent } from '@shared/directives/data-base.component';
import { SkipperCalculationService } from '../../services/skipper-calculation.service';
import { SkipperFormModel } from '@shared/models/forms/skipper-form.model';
import { environment } from '@environment/environment';

@Component({
  selector: 'app-skipper-haftpflicht-details',
  imports: [
    ReactiveFormsModule,
    TranslocoPipe,
    QuestionBoxComponent,
    PremiumDisplayComponent,
    NgClass,
    CalculationErrorDisplayComponent
  ],
  templateUrl: './skipper-haftpflicht-details.component.html',
  styleUrl: './skipper-haftpflicht-details.component.scss'
})
export class SkipperHaftpflichtDetailsComponent extends DataBaseComponent implements OnInit {
  @Input() form!: FormGroup<SkipperFormModel>;

  protected readonly skipperCalculationService = inject(SkipperCalculationService);

  protected readonly defaultAnswerOptions = defaultAnswerOptions;
  showCalculationPremiumEnabled = environment.featureToggles.showCalculationPremiumEnabled;

  ngOnInit(): void {
    this.form.valueChanges
      .pipe(
        startWith(this.form.value),
        switchMap(() => this.skipperCalculationService.calculate(this.form)),
        takeUntil(this.componentDestroyed$)
      )
      .subscribe();
  }

  canShowHasSchaedenBereitsErlitten(): boolean {
    return this.form.controls.skipperHaftpflicht.controls.hasBeantragteRisikenGekuendigtOderAbgelehnt.value === false ||
      (!!this.form.controls.skipperHaftpflicht.controls.hasBeantragteRisikenGekuendigtOderAbgelehnt.value &&
        this.isHasBeantragteRisikenGekuendigtOderAbgelehntValid());
  }

  isHasBeantragteRisikenGekuendigtOderAbgelehntValid(): boolean {
    return !!this.form.controls.skipperHaftpflicht.controls.versicherungsgesellschaftGekuendigtOderAbgelehnt.value &&
      !!this.form.controls.skipperHaftpflicht.controls.versicherungsgesellschaftYearGekuendigtOderAbgelehnt.value &&
      !!this.form.controls.skipperHaftpflicht.controls.versicherungsgesellschaftPolicyNumberGekuendigtOderAbgelehnt.value &&
      !!this.form.controls.skipperHaftpflicht.controls.versicherungsgesellschaftSparteGekuendigtOderAbgelehnt.value &&
      !!this.form.controls.skipperHaftpflicht.controls.versicherungsgesellschaftGrundGekuendigtOderAbgelehnt.value;
  }
}
